const oLimitDate = {
  oLimitDate: {
    title: {
      first: 'Tienes',
      second: 'días',
      third: 'disponibles',
      fourth: 'de tu prueba gratis de Vidroop'
    },

    firstParagraph: 'Pero estás a tiempo de aprovechar la OFERTA ESPECIAL de la licencia de Vidroop Inicia',

    link: {
      first: '> Si quiero mi ',
      second: 'DESCUENTO ESPECIAL',
      third: 'de Vidroop Inicia'
    },

    secondParagraph: {
      first: 'Aprovéchalo ya mismo que la oferta está por caducar.',
      second: '¡Es la última oportunidad!'
    }
  }
}

export default oLimitDate
